import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { translate } from '../Services/translation';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import FacetedSearch from './FacetedSearch';

const FacetedSearchCompact = () => {
    const { query } = useSelector((state) => state.quickSearch);
    const [showFilterNavigation, setShowFilterNavigation] = useState(false);

    const clearFilters = () => {
        const url = window.location.search.split(query && query != '' ? '&' : '?')[0];

        const urlWithoutParameters = window.location.origin + window.location.pathname;
        window.location = urlWithoutParameters + url;
    };

    return (
        <div className="faceted-search__compact-container hide-for-large">
            <button
                className="faceted-search__compact-button button-secondary"
                onClick={() => setShowFilterNavigation(!showFilterNavigation)}
            >
                <FilterListIcon />
                <span>{translate('facet.header.filter')}</span>
            </button>

            {showFilterNavigation && (
                <div className="faceted-search__compact-navigation">
                    <div className="faceted-search__compact-header">
                        {translate('facet.header.filter')}
                        <button onClick={() => setShowFilterNavigation(!showFilterNavigation)}>
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="faceted-search__compact-list">
                        <FacetedSearch />
                    </div>

                    <div className="faceted-search__compact-button--wrapper">
                        <button
                            className="faceted-search__compact-clear"
                            onClick={() => clearFilters()}
                        >
                            {translate('code.search.clearfilters')}
                        </button>
                        <button
                            className="faceted-search__compact-button--apply button"
                            onClick={() => setShowFilterNavigation(!showFilterNavigation)}
                        >
                            {translate('code.facet.button.applyfilters')}
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default FacetedSearchCompact;
